import { ApplicationRef, createComponent, inject, Injectable, TemplateRef } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { AlertComponent, AlertType } from "./alert.component";

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private nzMessageService: NzMessageService = inject(NzMessageService);
    private applicationRef: ApplicationRef = inject(ApplicationRef);
    
    public open(type: AlertType, message: string) {
        const componentRef = createComponent(AlertComponent, {
            environmentInjector: this.applicationRef.injector
        });

        const templateRef: TemplateRef<any> = componentRef.instance.alertTemplate();
        componentRef.setInput('type', type);
        componentRef.setInput('message', message);
        
        this.nzMessageService.error(templateRef).onClose.subscribe((value) => {
            if(value) {
                componentRef.destroy();
            }
        });

    }
}